import { ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import MetaCrmWidget from "@components/MetaCrmWidget";
import useBanner from "@hooks/useBanner";

export interface PageLayoutProps {
  children: ReactNode;
  RightSidebar?: ReactNode;
  extraMarginTop?: boolean;
}

const PageLayout = ({
  children,
  RightSidebar,
  extraMarginTop = true,
}: PageLayoutProps) => {
  const { showBanner } = useBanner();
  const extraMargin = extraMarginTop ? 2 : 0;
  const bannerMargin = showBanner ? 1.5 : 0;

  return (
    <>
      <MetaCrmWidget />
      <Box
        pt={{
          base: 0,
          lg: `${bannerMargin}rem`,
          xl: `${extraMargin + bannerMargin}rem`,
        }}
        mb={4}
        bg="backgroundCanvas"
      >
        <Box>{children}</Box>
        {RightSidebar && RightSidebar}
      </Box>
    </>
  );
};

export default PageLayout;
